export default __webpack_public_path__ + "static/media/Matsal3.787deb68.jpeg";